import { toPrettyDate } from '@/common/utils/formatting';
import VueI18n from '@/i18n';

export const today = new Date();
const tc = (key, choice) => VueI18n.tc(key, choice);

export const getDateDifferenceInDays = (startDate, endDate) => (
  Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24))
);


export const getPrettyDateDifferenceInDays = (startDate, endDate) => {
  let days = getDateDifferenceInDays(startDate, endDate);
  if (days < 0) {
    return toPrettyDate(endDate);
  }
  days = Math.abs(days);
  return `${days} ${tc('word.day', days).toLowerCase()}`;
};
